import React, { useRef, useState } from "react";
import { DefaultButton, Stack, Text } from "office-ui-fabric-react";
import { useTranslation } from "react-i18next";

interface IFileInputProps {
  name: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

// Native <input type="file"> renders its button and label in the browser language, so it is hidden behind a translated button
const FileInput: React.FC<IFileInputProps> = ({ name, onChange }) => {
  const { t } = useTranslation("admin");
  const inputRef = useRef<HTMLInputElement>(null);
  const [fileName, setFileName] = useState<string>("");

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files && event.target.files[0];
    setFileName(file ? file.name : "");
    onChange(event);
  };

  return (
    <Stack horizontal verticalAlign="center" tokens={{ childrenGap: 10 }}>
      <input type="file" name={name} ref={inputRef} onChange={handleChange} style={{ display: "none" }} />
      <DefaultButton text={t("nav.chooseFile") as string} onClick={() => inputRef.current && inputRef.current.click()} />
      <Text>{fileName || (t("nav.noFileChosen") as string)}</Text>
    </Stack>
  );
};

export default FileInput;
